import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-input-cell',
    templateUrl: './input-cell.component.html',
    styleUrls: ['./input-cell.component.scss'],
    standalone: false
})
export class InputCellComponent implements ICellRendererAngularComp {
  value: any;
  display: boolean;
  inValid: boolean = false;
  type: string;
  validateInput: boolean = false;
  private params: ICellRendererParams | any;

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.value = this.params.value;
    const dataParams = params?.colDef?.cellRendererParams;
    this.type = dataParams?.type ? dataParams?.type : 'string';
    this.display = dataParams?.display(params);
    this.validateInput = dataParams?.validateInput;
  }

  refresh(): boolean {
    return false;
  }

  onFocusOut(): void {
    this.params?.onFocusOut({ params: this.params?.data, value: this.value });
  }

  onInput(): void {
    const returnVal = this.params?.onInput({ params: this.params?.data, value: this.value });
    if (this.validateInput) {
      this.inValid = returnVal;
    }
  }
}
